import { MagentoSearchTerm } from 'lib/types'
import { History } from 'history'

export const createHandleSearchTermRouting = (deps: {
  pwaUrl: string | undefined
  history: History<unknown>
  searchPath: string
  value: string
}) => (searchTerm?: MagentoSearchTerm) => {
  const { pwaUrl, history, searchPath, value } = deps
  const _pwaUrl = pwaUrl ?? ''
  const redirectPath = searchTerm?.redirect?.includes(_pwaUrl)
    ? searchTerm?.redirect?.substr(_pwaUrl.length)
    : searchTerm?.redirect

  if (searchTerm?.redirect && redirectPath?.includes('http')) {
    window.location.href = searchTerm?.redirect
    return
  }

  if (redirectPath) {
    history.push(redirectPath)
    return
  }

  history.push(searchPath.replace(':query', encodeURIComponent(value)))
}
